import Vue from 'vue'

export default {
  setArenaAdverts (state, { adverts }) {
    state.adverts = adverts
  },

  clearArenaAdverts (state) {
    state.adverts = []
  },

  setArenaFilter (state, { filter }) {
    state.filter = filter
  },

  selectBidCard (state, { bidCard }) {
    state.selectedBidCard = bidCard
  },

  clearSelectedBidCard (state) {
    state.selectedBidCard = null
  },

  markAdvertAsRead (state, { id }) {
    let index = state.adverts.findIndex(ad => ad.id === id)
    if (index > -1) {
      state.adverts[index] = { ...state.adverts[index], userAdNote: { markedAsRead: true } }
    }
  },

  markAdvertAsHidden (state, { id }) {
    state.adverts = state.adverts.filter(advert => advert.id !== id)
  },

  makeBid (state, { id, bidSession }) {
    let advert = state.adverts.find(ad => ad.id === id)
    if (advert) {
      Vue.set(advert, 'isUserBidded', true)
      Vue.set(advert, 'lastBidsession', bidSession)
    }
  },

  setAuctionId (state, { id }) {
    state.auctionId = id
  },

  setIntervalFrom (state, { intervalFrom }) {
    state.intervalFrom = intervalFrom
  },

  setIntervalTo (state, { intervalTo }) {
    state.intervalTo = intervalTo
  },

  setStockExchangeEmployerSearchOccupations (state, { occupations }) {
    state.employerSearchOccupations = occupations
  },

  resetArena (state) {
    state.adverts = []
    state.auctionId = 0
    state.employerSearchOccupations = []
    state.filter = null
    state.intervalFrom = ''
    state.intervalTo = ''
    state.isSearchTriggered = false
    // Do not reset selected bid card here, because the reset mutation runs every time the Arena is opened
    // state.selectedBidCard = null
  },

  resetSelectedBidCard (state) {
    state.selectedBidCard = null
  },

  triggerArenaSearch (state) {
    state.isSearchTriggered = true
  },

  resetArenaSearchTrigger (state) {
    state.isSearchTriggered = false
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/arena/mutations.js